var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "link-2-outline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.301897321
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop_1_1",
    transform: "translate(-538.000000, -489.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy",
    transform: "translate(485.000000, 394.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(40.000000, 82.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "link-2-outline",
    transform: "translate(13.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    opacity: 0,
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9675,6.9675 L6.9675,9.9675 C6.82551551,10.1083249 6.74565126,10.3000218 6.74565126,10.5 C6.74565126,10.6999782 6.82551551,10.8916751 6.9675,11.0325 C7.10832495,11.1744845 7.30002185,11.2543487 7.5,11.2543487 C7.69997815,11.2543487 7.89167505,11.1744845 8.0325,11.0325 L11.0325,8.0325 C11.3265916,7.73840837 11.3265916,7.26159163 11.0325,6.9675 C10.7384084,6.67340837 10.2615916,6.67340837 9.9675,6.9675 L9.9675,6.9675 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.21,13.05 L8.25,14.0025 C7.13426367,15.1521853 5.33331489,15.2812856 4.065,14.3025 C3.41020205,13.7629286 3.01450525,12.9713171 2.97591348,12.1237274 C2.9373217,11.2761376 3.25944436,10.451843 3.8625,9.855 L4.9275,8.7825 C5.06948449,8.64167505 5.14934874,8.44997815 5.14934874,8.25 C5.14934874,8.05002185 5.06948449,7.85832495 4.9275,7.7175 C4.78667505,7.57551551 4.59497815,7.49565126 4.395,7.49565126 C4.19502185,7.49565126 4.00332495,7.57551551 3.8625,7.7175 L2.91,8.6775 C1.25049962,10.2845145 1.03573394,12.8713191 2.4075,14.73 C3.20383457,15.7630856 4.4056462,16.404235 5.70718432,16.4903345 C7.00872244,16.576434 8.28451861,16.0991838 9.21,15.18 L10.275,14.115 C10.5690916,13.8209084 10.5690916,13.3440916 10.275,13.05 C9.98090837,12.7559084 9.50409163,12.7559084 9.21,13.05 L9.21,13.05 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.745,2.415 C12.8731004,1.02867362 10.2630949,1.24697666 8.6475,2.925 L7.8375,3.75 C7.65027379,3.88610706 7.52952304,4.09520436 7.50521714,4.3253956 C7.48091123,4.55558684 7.5553288,4.78529197 7.71,4.9575 C7.85082495,5.09948449 8.04252185,5.17934874 8.2425,5.17934874 C8.44247815,5.17934874 8.63417505,5.09948449 8.775,4.9575 L9.75,3.975 C10.860094,2.81972216 12.6637199,2.69019786 13.9275,3.675 C14.5872457,4.21469409 14.9862697,5.00955269 15.0249089,5.86104615 C15.0635481,6.71253961 14.7381542,7.54027095 14.13,8.1375 L13.065,9.21 C12.9230155,9.35082495 12.8431513,9.54252185 12.8431513,9.7425 C12.8431513,9.94247815 12.9230155,10.1341751 13.065,10.275 C13.2058249,10.4169845 13.3975218,10.4968487 13.5975,10.4968487 C13.7974782,10.4968487 13.9891751,10.4169845 14.13,10.275 L15.195,9.21 C16.1115772,8.28470997 16.5871629,7.01066738 16.5010991,5.71110271 C16.4150352,4.41153804 15.7755923,3.21133841 14.745,2.415 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.a5c7494c7c1980655bb2c8c44d3c7a3d.svg";
export { ForwardRef as ReactComponent };